import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
// import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

if($('.event-carousel').length) {

    $('.event-carousel').each(function () {

        $(this).slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            infinite: false,
            dots: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                },
            ]
        });

    });

}

if($('.split-carousel').length) {

    $('.split-carousel.carousel-on').each(function () {

        $(this).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true
        });

    });

}

if($('.team-bio-carousel').length) {

    $('.team-bio-carousel').each(function () {

        const bioCarousel = new Swiper(this, {
            slidesPerView: 1,
            spaceBetween: 0,
            // loop: true,
            autoHeight: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            modules: [Navigation, Pagination],
            // pagination: {
            //     el: '.swiper-pagination',
            //     clickable: true,
            // },
        });

        $('.team-member-inner').on('click', function () {
            let index = $(this).data('index');

            bioCarousel.slideTo(index);
        });

    });

}

if($('.blog-listings-home-mobile').length) {

    if($(window).width() <= 991) {
        $('.blog-listings-home-mobile').slick({
            infinite: false,
            dots: true
        });
    }

}

if($('.testimonial-listings-mobile').length) {

    if($(window).width() <= 991) {
        $('.testimonial-listings-mobile').slick({
            infinite: false,
            dots: true
        });
    }

}

if($('.blog-listings-mobile').length) {

    if($(window).width() <= 991) {
        $('.blog-listings-mobile').each(function () {
            $(this).slick({
                infinite: false,
                dots: true,
                adaptiveHeight: true
            });
        });
    }

}

if($('.videos-slideshow').length) {

    $('.video-slideshow-object').slick({
        slidesToShow: 1,
        infinite: false,
        dots: true
    });

}
